import { render, staticRenderFns } from "./OnOffSlider.vue?vue&type=template&id=27868b2f&scoped=true&"
import script from "./OnOffSlider.vue?vue&type=script&lang=js&"
export * from "./OnOffSlider.vue?vue&type=script&lang=js&"
import style0 from "./OnOffSlider.vue?vue&type=style&index=0&id=27868b2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27868b2f",
  null
  
)

export default component.exports